import { Surname } from "../../entities/surname"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	surnameId: string
}

export async function surnameUnrelateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/surname/unrelate/v1"
	const requester = new ApiRequester<RequestDataShape, Surname>(endpoint)
	return await requester.sendRequest(payload, token)
}
